(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('darkModeToggle', darkModeToggle);

    darkModeToggle.$inject = ['darkModeSvc'];

    function darkModeToggle(darkModeSvc) {
        return {
            restrict: 'E',
            template: `
                <div class="dark-mode-toggle-wrapper" ng-click="toggleDarkMode()">
                    <button type="button" class="dark-mode-toggle-btn" 
                            title="{{ isDark ? ('Switch to Light Mode' | translate) : ('Switch to Dark Mode' | translate) }}">
                        <i class="ei-light" ng-show="isDark"></i>
                        <i class="ei-dark" ng-show="!isDark"></i>
                        <span class="toggle-text" ng-if="showText">{{ isDark ? ('Light Mode' | translate) : ('Dark Mode' | translate) }}</span>
                    </button>
                </div>
            `,
            scope: {
                showText: '=?' // Optional: show text label
            },
            link: function (scope, element, attrs) {
                // Initialize state
                scope.isDark = darkModeSvc.isDarkMode();

                // Toggle function
                scope.toggleDarkMode = function () {
                    scope.isDark = darkModeSvc.toggle();
                };

                // Listen for external dark mode changes
                scope.$on('darkMode:changed', function (event, data) {
                    scope.isDark = data.enabled;
                });
            }
        };
    }
})();

